import axios from 'axios';
import {
  handleSingleDeviceSessionExpired,
  SINGLE_DEVICE_SESSION_EXPIRED_CODE,
} from './sessionExpiryHandler';

let isRegistered = false;

/**
 * default axios에 401 + SINGLE_DEVICE_SESSION_EXPIRED 세션 만료 인터셉터를 1회만 등록
 * tokens.ts, methodHelpers.ts에서 import만 하면 등록됨 (중복 등록 방지)
 */
export const registerDefaultAxiosSessionExpiry = (): void => {
  if (isRegistered) return;
  isRegistered = true;

  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      const status = error?.response?.status;
      const data = (error?.response?.data ?? {}) as { errorCode?: string; errorMessage?: string };

      const isSingleDeviceSessionExpired = status === 401 && data.errorCode === SINGLE_DEVICE_SESSION_EXPIRED_CODE;
      if (isSingleDeviceSessionExpired) handleSingleDeviceSessionExpired(data.errorMessage!!);

      return Promise.reject(error);
    },
  );
};
